import { useState, useEffect, useRef } from 'react'
import { LOC_COLOR, LOC_LABEL } from '../../data/seed.js'

export const INP_STYLE={background:"var(--bg2)",border:"1px solid var(--border2)",borderRadius:2,padding:"9px 12px",fontSize:11,color:"var(--text)",width:"100%",outline:"none",fontFamily:"'Courier New',monospace",boxSizing:"border-box"};

function Field({label,required,children}){
  return(
    <div style={{marginBottom:14}}>
      <label style={{display:"block",fontSize:9,letterSpacing:3,color:"var(--text4)",marginBottom:7}}>
        {label}{required&&<span style={{color:"#ff4757"}}> *</span>}
      </label>
      {children}
    </div>
  );
}
function TInp({value,onChange,type="text",placeholder,onEnter}){
  return <input style={{...INP_STYLE}} type={type} value={value} onChange={e=>onChange(e.target.value)} onKeyDown={e=>e.key==="Enter"&&onEnter&&onEnter()} placeholder={placeholder}/>;
}
function LocBtn({locKey,selected,onSelect,disabled}){
  const c=LOC_COLOR[locKey];
  return(
    <button onClick={()=>!disabled&&onSelect(locKey)} disabled={disabled}
      style={{flex:1,background:selected?c+"28":"var(--bg)",border:selected?`1px solid ${c}55`:"1px solid var(--border2)",color:selected?c:"var(--text4)",padding:"8px 4px",fontSize:9,letterSpacing:1,cursor:disabled?"not-allowed":"pointer",borderRadius:2,opacity:disabled?.25:1,fontWeight:selected?700:400}}>
      {LOC_LABEL[locKey]}
    </button>
  );
}
function Overlay({onClose,children,zIndex=1000,wide=false,maxWidth=460}){
  const mw=wide?"min(920px,98vw)":`min(${maxWidth}px,98vw)`;
  const mouseDownOnBackdrop=useRef(false);

  // UX Fix: Trava o scroll da página enquanto o modal estiver aberto
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = originalStyle; };
  }, []);
  const handleBackdropMouseDown=(e)=>{
    // Registra se o clique começou no backdrop (não no conteúdo)
    mouseDownOnBackdrop.current=(e.target===e.currentTarget);
  };
  const handleBackdropMouseUp=(e)=>{
    // Só fecha se o mousedown E o mouseup foram ambos no backdrop
    if(mouseDownOnBackdrop.current&&e.target===e.currentTarget)onClose();
    mouseDownOnBackdrop.current=false;
  };
  return(
    <div
      style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",display:"flex",alignItems:"center",justifyContent:"center",zIndex,padding:"12px 16px",overflowY:"auto"}}
      onMouseDown={handleBackdropMouseDown}
      onMouseUp={handleBackdropMouseUp}
    >
      <div className="overlay-inner" style={{background:"var(--bg2)",border:"1px solid var(--border2)",borderRadius:2,padding:wide?"28px 32px":28,width:"100%",maxWidth:mw,maxHeight:"92vh",overflowY:"auto",flexShrink:0}}
        onMouseDown={e=>e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
function ModalHead({title,color,onClose}){
  return(
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
      <span style={{fontSize:10,letterSpacing:3,color,fontWeight:700}}>{title}</span>
      <button style={{background:"none",border:"none",color:"var(--text3)",fontSize:18,cursor:"pointer"}} onClick={onClose}>✕</button>
    </div>
  );
}
function Badge({children,color}){
  return <span style={{fontSize:9,letterSpacing:1,padding:"2px 8px",border:`1px solid ${color}44`,borderRadius:2,background:color+"18",color}}>{children}</span>;
}
function ActionBtn({children,onClick,color,style={}}){
  return <button onClick={onClick} style={{background:"none",border:`1px solid ${color}44`,color,fontSize:9,letterSpacing:2,padding:"6px 12px",cursor:"pointer",borderRadius:2,...style}}>{children}</button>;
}
function PrimaryBtn({children,onClick,color="#ffa502",textColor="#000",style={}}){
  return <button onClick={onClick} style={{background:color,border:"none",color:textColor,padding:"11px 20px",fontWeight:700,fontSize:10,letterSpacing:2,cursor:"pointer",borderRadius:2,fontFamily:"'Courier New',monospace",...style}}>{children}</button>;
}
function GhostBtn({children,onClick,style={}}){
  return <button onClick={onClick} style={{background:"var(--bg3)",border:"1px solid var(--border2)",color:"var(--text3)",padding:"11px 20px",fontWeight:700,fontSize:10,letterSpacing:2,cursor:"pointer",borderRadius:2,fontFamily:"'Courier New',monospace",...style}}>{children}</button>;
}
function SyncClock({lastSync,onSync}){
  const [now,setNow]=useState(Date.now());
  const [hover,setHover]=useState(false);
  useEffect(()=>{const t=setInterval(()=>setNow(Date.now()),60000);return()=>clearInterval(t);},[]);
  let label="nunca sincronizado";
  if(lastSync!==null){
    const diff=Math.floor((now-lastSync)/60000);
    if(diff===0)label="sincronizado agora";
    else if(diff<60)label=`há ${diff}min`;
    else if(diff<1440)label=`há ${Math.floor(diff/60)}h`;
    else label="há 24h+";
  }
  const tsFormatado=lastSync?new Date(lastSync).toLocaleString("pt-BR",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"}):"—";
  return(
    <div style={{position:"relative",display:"inline-flex"}}
      onMouseEnter={()=>setHover(true)} onMouseLeave={()=>setHover(false)}>
      <button onClick={onSync}
        style={{background:"none",border:"1px solid var(--border2)",color:"var(--text3)",padding:"5px 10px",fontSize:9,letterSpacing:2,cursor:"pointer",borderRadius:2,display:"flex",alignItems:"center",gap:5,whiteSpace:"nowrap"}}>
        ⟳ SYNC
      </button>
      {hover&&(
        <div style={{position:"absolute",top:"calc(100% + 8px)",right:0,zIndex:9999,background:"var(--bg2)",border:"1px solid var(--border2)",borderRadius:3,padding:"10px 14px",minWidth:220,boxShadow:"0 4px 16px rgba(0,0,0,.4)",pointerEvents:"none"}}>
          <p style={{fontSize:9,color:"var(--text4)",letterSpacing:2,marginBottom:6}}>SINCRONIZAÇÃO</p>
          <p style={{fontSize:10,color:"var(--text)",fontWeight:600,marginBottom:4}}>{label}</p>
          {lastSync&&<p style={{fontSize:9,color:"var(--text3)",marginBottom:8}}>Última: {tsFormatado}</p>}
          <div style={{borderTop:"1px solid var(--border)",paddingTop:8}}>
            <p style={{fontSize:9,color:"var(--text4)",lineHeight:1.6}}>Varre o Mercado Livre e o Omie ERP em busca de novas movimentações de estoque.</p>
          </div>
        </div>
      )}
    </div>
  );
}

export { Field, TInp, LocBtn, Overlay, ModalHead, Badge, ActionBtn, PrimaryBtn, GhostBtn, SyncClock }
